(function (root, factory) {
  const api = factory();
  if (typeof module === "object" && module.exports) module.exports = api;
  else root.PataCommerce = api;
})(typeof globalThis !== "undefined" ? globalThis : this, function () {
  "use strict";
  function nextQuantity(
    value,
    direction,
    minimum = 1,
    increment = 1,
    maximum = "",
  ) {
    const min = Math.max(0, Math.floor(Number(minimum) || 0));
    const step = Math.max(1, Math.floor(Number(increment) || 1));
    const suppliedMax =
      maximum === "" || maximum == null ? Infinity : Number(maximum);
    const max = Number.isFinite(suppliedMax)
      ? Math.max(min, min + Math.floor((suppliedMax - min) / step) * step)
      : Infinity;
    const parsed = Number(value);
    if (value === "" || !Number.isFinite(parsed)) return min;
    const current = Math.min(max, Math.max(min, parsed));
    const offset = (current - min) / step;
    const next =
      min +
      (direction > 0 ? Math.floor(offset) + 1 : Math.ceil(offset) - 1) * step;
    return Math.min(max, Math.max(min, next));
  }
  function localeRoot(value = "/") {
    return `${String(value || "/").replace(/\/$/, "")}/`;
  }
  async function settledMap(items, mapper, concurrency = 4) {
    const results = new Array(items.length);
    let next = 0;
    await Promise.all(
      Array.from({ length: Math.min(concurrency, items.length) }, async () => {
        while (next < items.length) {
          const index = next++;
          try {
            results[index] = {
              status: "fulfilled",
              value: await mapper(items[index]),
            };
          } catch (reason) {
            results[index] = { status: "rejected", reason };
          }
        }
      }),
    );
    return results;
  }
  return { nextQuantity, localeRoot, settledMap };
});
